// api/encryptionApi.js
import axios from "axios";
import CryptoJS from "crypto-js";

let TOKEN_KEY = "";
let SECRET_KEY = null;
let IV = null;
let BASE_URL = window.location.origin; // backend base URL
if (window.location.origin === "http://localhost:3000") {
    BASE_URL = "https://uat.herohousingfinance.com";
}

// Init session keys from backend
async function initSession() {
    const res = await axios.post(`${BASE_URL}/api/get-token`, {
        params: { url: window.location.href, userAgent: navigator.userAgent, }
    });
    const decryptedConfigStr = CryptoJS.AES.decrypt(
        res.data.encryptedData,
        'BUiJ6YioLLCKGgRJdaJZ2NTrunwJOBvf'
    ).toString(CryptoJS.enc.Utf8);

    let CONFIG = JSON.parse(decryptedConfigStr);
    SECRET_KEY = CryptoJS.enc.Base64.parse(CONFIG.secret);
    IV = CryptoJS.enc.Base64.parse(CONFIG.iv);
    TOKEN_KEY = CONFIG.apiAuth.token;
}

// Encrypt function
function encryptData(data) {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY, {
        iv: IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    }).toString();
}

// Decrypt function
function decryptData(encrypted) {
    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY, {
        iv: IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}

// Create axios instance
const api = axios.create({
    baseURL: BASE_URL + '/api',
    headers: { "Content-Type": "application/json" },
});

// Request interceptor: auto encrypt + attach token
api.interceptors.request.use(async (config) => {
    if (!SECRET_KEY || !IV) await initSession();
    const token = TOKEN_KEY;
    if (!token) throw new Error("Token not found");
    config.headers.Authorization = `Bearer ${token}`;
    if (config.data && !(config.data instanceof FormData)) {
        config.data = { payload: encryptData(config.data) };
    }
    return config;
});

// Response interceptor: auto decrypt
api.interceptors.response.use((res) => {
    if (res.data?.payload) {
        return decryptData(res.data.payload);
    }
    return res.data;
});

export default api;
